import { Game } from 'chessboard/model/game/types';

/**
 * Determine from the flags if a move is a capture.
 */
export function isCapture(move: Game.Move.Model): boolean {
  if (move.flags === undefined) {
    return false;
  }

  // In binary representation, a capture always ends in a '1', so doing
  // a bitwise & with 1 lets us know if it's a capture. The only exception
  // is the en passant capture, which we check for separately.
  // eslint-disable-next-line no-bitwise
  return Boolean((move.flags & 1) === 1) || move.flags === Game.Move.Flags.EPCapture;
}
